var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgEarInfectionDogRebrand = function SvgEarInfectionDogRebrand(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 36 24"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#Ear-Infection-Dog-rebrand_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#023B64",
    d: "M7.177 1.903c-1.234 0-3.585.102-5.311 1.373 0 0-2.49 1.77-1.712 5.157 0 0 .537 2.828 1.558 4.326 0 0 .837 1.197 1.711-.073 0 0 1.11-1.675 1.66-2.755l3.29-3.092c.14-.118.537-4.93.581-4.951h-1.77v.015z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F0C196",
    d: "M33.23 19.56 28.64 8.955a.713.713 0 0 1 .382-.962.713.713 0 0 1 .962.382l4.591 10.607a.713.713 0 0 1-.382.962c-.374.154-.808 0-.962-.382"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#023B64",
    d: "m28.53 7.962.698-2.108c-.463-1.696-1.697-2.578-1.697-2.578-1.726-1.278-4.077-1.366-5.311-1.38h-1.8l1.712 6.493 2.16 1.733c.77 1.175 1.696 2.57 1.696 2.57.89 1.279 1.712.082 1.712.082.514-.771.91-1.88 1.168-2.777-.397-.117-.14-1.608-.323-2.02z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0074AF",
    d: "M14.684 0C10.4 0 6.802 2.784 5.546 6.64c-.89 2.82-.463 5.737.999 8.073a5.8 5.8 0 0 0-.375 2.02c0 3.79 3.805 6.868 8.514 6.868s8.506-3.078 8.506-6.868c0-.705-.125-1.388-.375-2.02a9.6 9.6 0 0 0 1.462-4.598C24.57 4.547 20.127 0 14.69 0h-.015z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FEF4EC",
    d: "M30.623 7.992a1.468 1.468 0 1 1-2.696 1.16l-.58-1.351a1.468 1.468 0 1 1 2.696-1.16zM35.883 20.127a1.468 1.468 0 1 1-2.696 1.16l-.58-1.351c-.324-.75.029-1.61.77-1.932.75-.316 1.61.03 1.925.77z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#023B64",
    d: "M18.004 9.226c.808 0 1.461-.654 1.461-1.47 0-.815-.653-1.461-1.461-1.461a1.46 1.46 0 0 0-1.462 1.462c0 .808.654 1.469 1.462 1.469M11.393 9.226a1.46 1.46 0 0 0 1.461-1.462c0-.808-.653-1.469-1.461-1.469s-1.462.654-1.462 1.47c0 .814.654 1.46 1.462 1.46M14.698 20.244a.737.737 0 0 1-.734-.735v-2.945c0-.411.33-.727.734-.727s.735.33.735.727v2.945a.737.737 0 0 1-.735.735"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#023B64",
    d: "M15.433 13.633c.808 0 1.462.654 1.462 1.47 0 .815-.654 1.461-1.462 1.461H13.97a1.46 1.46 0 0 1-1.462-1.462c0-.808.654-1.469 1.462-1.469z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "Ear-Infection-Dog-rebrand_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h36v23.601H0z"
  })))));
};
export default SvgEarInfectionDogRebrand;